import { Decimal } from "decimal.js";

export default {
 methods: {
  async nutrientFormulation(formulationArray, ingredients, parameters) {
   //code for fft formulation algorithm

   let returnParameters = parameters.map(item => {
    return { measurement_unit: item.measurement_unit, internal_name: item.internal_name, name: item.name, value: 0, ...item };
   });

   ingredients.map(item => {
    const constraintName = item.id ? item.internal_name + "_" + item.id : item.internal_name;

    if (formulationArray[constraintName]) {
     for (let returnParameter of returnParameters) {
        returnParameter.internal_name == "adj_dig_p_min"
         ? console.log(item[returnParameter.internal_name], formulationArray[constraintName], constraintName)
         : null;
      returnParameter.value = returnParameter.value + item[returnParameter.internal_name] * formulationArray[constraintName] * 0.01;
     }
    }
   });

   for (let returnParameter of returnParameters) {
    returnParameter.internal_name == "adj_dig_p_max" ? console.log(returnParameter.value) : null;
    if (returnParameter.value > 0.001) {
     returnParameter.value = +(Math.round(new Decimal(returnParameter.value) + "e+2") + "e-2");
    }
   }

   //   console.log(ingredients);
   //   console.log(returnParameters)

   //   console.log("formulation", formulationArray);
   return returnParameters;
  },
 },
 data() {
  return {};
 },
};
